import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Button, Stack } from "@mui/material";
import { useCallback, useState } from "react";
import { Link } from "react-router";
import type { SmartViewWidget } from "../../../../../api/types/dashboardsTypes";
import SwitchField from "../../../reporting/sv/components/common/SwitchField";
import WidgetSettingsComponent from "../../components/widgets-toolbox/WidgetSettingsComponent";

interface Props {
  widget: SmartViewWidget;
  onSave: (widgetId: string, properties: Partial<SmartViewWidget>) => void;
}

const SmartViewWidgetSettingsComponent = ({ widget, onSave }: Props) => {
  const [settings, setSettings] = useState<SmartViewWidget>(widget);

  const handleChange = (properties: Partial<SmartViewWidget>) => {
    setSettings((prev) => ({ ...prev, ...properties }));
  };

  const handleApply = useCallback(() => {
    onSave(widget.widgetId, settings);
  }, [widget.widgetId, settings, onSave]);

  return (
    <WidgetSettingsComponent widget={widget} showApplyButton={true} onApply={handleApply}>
      <Stack direction="column" useFlexGap spacing={1} sx={{ p: 2 }}>
        <Link to={`./widgets/${widget.widgetId}/edit`}>
          <Button variant="outlined" color="secondary" startIcon={<SettingsOutlinedIcon />} fullWidth>
            Edit Report
          </Button>
        </Link>
        <SwitchField
          label="Hide Widget Title"
          checked={settings.hideTitle}
          onChange={(hideTitle) => handleChange({ hideTitle })}
        />
      </Stack>
    </WidgetSettingsComponent>
  );
};

export default SmartViewWidgetSettingsComponent;
